import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'mr-3': _ctx.margin }, "bg-theme-primary rounded-xl text-center overflow-hidden font-medium flex-1 lg:max-w-[120px] w-full"])
  }, [
    _createElementVNode("div", {
      class: "p-2 text-sm md:text-base uppercase text-white bg-theme-primary",
      textContent: _toDisplayString(_ctx.label)
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "p-2 text-2xl md:text-3xl font-bold bg-green-100 text-theme-primary",
      textContent: _toDisplayString(_ctx.value)
    }, null, 8, _hoisted_2)
  ], 2))
}